import { useState } from "react";

const ExtendedDescription = ({ text }) => {

    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpanded = () => setIsExpanded(!isExpanded);

    if (!text) {
        // If text is null or undefined, display a fallback message or return null
        return <span style={{ color: "gray", fontStyle: "italic" }}>No data available</span>;
    }

    // Calculate the number of characters hidden
    const hiddenCharCount = text.length - 128;

    const formatNumber = (num) => {
        num = parseFloat(num);
        const [integerPart, decimalPart] = num.toString().split('.');

        // Format the integer part with commas
        const formattedIntegerPart = integerPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

        // Return the formatted number with the original decimal part (if present)
        return decimalPart ? `${formattedIntegerPart}.${decimalPart}` : formattedIntegerPart;
    }

    return (
        <span>
            {isExpanded || text.length <= 128 ? text : `${text.slice(0, 128)}... `}&nbsp;
            {text.length > 128 && (
                <button
                    onClick={toggleExpanded}
                    style={{
                        background: "none",
                        border: "none",
                        color: "var(--bs-info)",
                        textDecoration: "underline",
                        cursor: "pointer",
                        padding: 0
                    }}
                >
                    {isExpanded ? "See Less" : `See More (${formatNumber(hiddenCharCount)})`}
                </button>
            )}
        </span>
    );
}

export default ExtendedDescription;